import React, { useState } from 'react';
import { X, ZoomIn, ChevronLeft, ChevronRight } from 'lucide-react';

export const PhotoViewer = ({ photos, initialIndex = 0, onClose }) => {
  const [index, setIndex] = useState(initialIndex);
  if (!photos || photos.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center" onClick={onClose} data-testid="photo-viewer-overlay">
      <button onClick={onClose} className="absolute top-4 right-4 text-white hover:text-slate-300 z-10" data-testid="photo-viewer-close">
        <X className="w-8 h-8" />
      </button>
      {photos.length > 1 && (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 text-white text-sm font-medium bg-black/50 px-3 py-1 rounded-full">
          {index + 1} / {photos.length}
        </div>
      )}
      {photos.length > 1 && index > 0 && (
        <button onClick={(e) => { e.stopPropagation(); setIndex(i => i - 1); }}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-slate-300 bg-black/40 rounded-full p-2" data-testid="photo-viewer-prev">
          <ChevronLeft className="w-8 h-8" />
        </button>
      )}
      {photos.length > 1 && index < photos.length - 1 && (
        <button onClick={(e) => { e.stopPropagation(); setIndex(i => i + 1); }}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-slate-300 bg-black/40 rounded-full p-2" data-testid="photo-viewer-next">
          <ChevronRight className="w-8 h-8" />
        </button>
      )}
      <img
        src={photos[index]}
        alt="Photo"
        className="max-w-[90vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="photo-viewer-image"
      />
      <a href={photos[index]} target="_blank" rel="noreferrer"
        className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-xs bg-black/50 px-3 py-1.5 rounded-full hover:bg-black/70 flex items-center gap-1.5"
        onClick={(e) => e.stopPropagation()} data-testid="photo-viewer-open-tab">
        <ZoomIn className="w-3.5 h-3.5" /> Ouvrir en plein ecran
      </a>
    </div>
  );
};
